import React from 'react';
import { NButton, NIcon } from '@innersource-nn/novoui-react';
import { useModal } from 'hooks/useModal';
import { Environment } from 'types/Environment';

interface EmptyUserProfilesProps {
    environment: Environment;
}
export default function EmptyUserProfiles({
    environment,
}: EmptyUserProfilesProps) {
    const { openUserProfilesModal } = useModal();

    return (
        <div className="empty-place-holder items-center">
            <div className="flex flex-col items-center">
                <div className="round-div-icon-middle bg-light-blue-200 h-[5rem]	w-[5rem] ">
                    <NIcon
                        iconName="help"
                        size="normal"
                        className="fill-true-blue"
                    />
                </div>
                <p className="text-true-blue w-2/3 text-center mt-8">
                    Looks like you have not set up user profile yet, get started
                    below.
                </p>
                <p className="mt-12">
                    <NButton
                        className="bg-sea-blue-600"
                        variant="fill"
                        square
                        onClick={() =>
                            openUserProfilesModal({
                                environment,
                            })
                        }
                    >
                        Create user profile
                    </NButton>
                </p>
            </div>
        </div>
    );
}
